import { PANEL_AREA_SOURCE_NAV_MODES } from "./PanelAreaSourceNav.const";

export const nextToggleNavMod = (navMode: string): string => {
  const nextMode =
    navMode === PANEL_AREA_SOURCE_NAV_MODES.CONTENT
      ? PANEL_AREA_SOURCE_NAV_MODES.STRUCTURE
      : PANEL_AREA_SOURCE_NAV_MODES.CONTENT;
  return nextMode;
};
